"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAM = exports.Agent = void 0;
const config_1 = require("./config");
const criteria_1 = require("./criteria");
const mesure_1 = require("./mesure");
const utils_1 = require("./utils");
const uuid_1 = require("uuid");
class Agent {
    constructor() {
    }
}
exports.Agent = Agent;
class SAM extends Agent {
    constructor(criteriaList) {
        super();
        this.nb_rep = 0;
        this.dataStream = new utils_1.DefaultDict(Array);
        if (criteriaList) {
            this.criteriaList = (0, config_1.configHandler)(criteriaList, criteria_1.criteriaDict, mesure_1.mesureDict);
        }
        else {
            let listOfConfigParam = [{
                    'criteria': 'comparaison',
                    'id': 'comparaison',
                    'mesure': 'mmp',
                    'param': { 'nb_step': 4, 'threshold': 0.75, 'stepToCompute': 4, 'tolerance': 0.1 }
                },
                {
                    'criteria': 'flag',
                    'id': 'flag',
                    'mesure': 'score',
                    'param': { 'nb_step': 4, 'threshold': 0.4, 'stepToCompute': 4 }
                }];
            let criteriaList = (0, config_1.configHandler)(listOfConfigParam, criteria_1.criteriaDict, mesure_1.mesureDict);
            this.criteriaList = criteriaList;
        }
        this.eventList = {};
        for (let criteria of this.criteriaList) {
            this.eventList[criteria.id] = new utils_1.DefaultDict(utils_1.defaultEventList);
        }
    }
    new_event(event) {
        var _a, _b, _c, _d, _e, _f;
        this.current_event = event;
        this.actID = (_c = (_b = (_a = event.categoryData.parentItems) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "undefinedActId";
        this.objID = (_f = (_e = (_d = event.categoryData.parentItems) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : "undefinedObjId";
        this.dataStream[this.actID].push(event.data.score);
        this.dataStream[this.objID].push(event.data.score);
    }
    check_criterias(eventStream) {
        for (let criteria of this.criteriaList) {
            // check if the criteria is detecting something in an objective
            let result_obj = criteria.update(this.dataStream[this.objID], this.eventList[criteria.id][this.objID]);
            // check if the criteria is detecting something in an activity
            let result = criteria.update(this.dataStream[this.actID], this.eventList[criteria.id][this.actID]);
            //if result in objective emit an AIScoreVariationEvent with graphLevel set to objective
            if (result_obj) {
                this.eventList[criteria.id][this.objID] = result_obj;
                if (result_obj.type == "scoreVariation") {
                    result_obj.graphLevel = 'objective';
                    this.generate_and_emit_event(result_obj, eventStream);
                }
            }
            //if result in activity emit an AIScoreVariationEvent with graphLevel set to activity
            if (result) {
                this.eventList[criteria.id][this.actID] = result;
                if (result.type == "scoreVariation") {
                    result.graphLevel = 'activity';
                    this.generate_and_emit_event(result, eventStream);
                }
            }
        }
    }
    generate_and_emit_event(event, eventStream) {
        var _a;
        let athenaEvent = {
            id: (0, uuid_1.v4)(),
            type: "AIScoreVariationEvent",
            createdAt: new Date().toISOString(),
            data: this.generate_data(event),
            userId: this.current_event.userId,
            sessionId: this.current_event.sessionId,
            app: (_a = this.current_event.app) !== null && _a !== void 0 ? _a : 'undefinedApp',
            categoryData: {
                author: "SAM",
                workmode: this.current_event.categoryData.workmode
            },
        };
        eventStream.publish(athenaEvent);
    }
    updateFromEvent(event, eventStream) {
        this.nb_rep++;
        this.new_event(event);
        this.check_criterias(eventStream);
    }
    updateFromEvent_with_seq(datas, eventStream) {
        for (let data of datas) {
            this.updateFromEvent(data, eventStream);
        }
    }
    generate_data(event) {
        var _a, _b, _c;
        let data = {
            moduleId: (_c = (_b = (_a = this.current_event.categoryData.parentItems) === null || _a === void 0 ? void 0 : _a[2]) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : "undefinedModuleId",
            objectiveId: this.objID,
            activityId: this.actID,
            exerciseId: this.current_event.categoryData.learningItem.id,
            graphLevel: event.graphLevel,
            variationType: event.data['type'],
            variationData: Object.assign(Object.assign({}, event.data), { score: this.dataStream[this.actID].at(-1) }),
        };
        return data;
    }
}
exports.SAM = SAM;
